import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { Client } from 'src/app/shared/models/client.model';
import { ClientFilter } from 'src/app/shared/models/clientFilter.model';
import { ClientService } from 'src/app/shared/services/core/client.service';

@Component({
  selector: 'app-clientes',
  imports: [TegelModule, CommonModule],
  templateUrl: './clientes.component.html',
  styleUrl: './clientes.component.scss'
})
export class ClientesComponent implements OnInit {
  clients: Client[];
  clientFilter: ClientFilter;
  page = 1;
  searchText = '';
  order = "id";
  total!: number;

  constructor(private utilService: UtilService,
              private dialogService: DialogService,
              private clientService: ClientService,
              private toastr: ToastrService
  ){
    this.clients = [];
    this.clientFilter = new ClientFilter();
  }

  ngOnInit(): void {
    
  }

  getClients(page: number) {
    this.clientService.get(page, this.clientFilter).subscribe((result) => {
      if (result) {
        this.clients = result.page;
        this.page = result.currentPage;
        this.total = result.totalRecords;
      }
    });
  }

  deleteClient(client: Client){
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir o cliente ' + client.cnpj + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        this.clientService.delete(client.id).subscribe((result) => {
          if (result && !result.hasErrors) {
            let index = 0;
            do { 
              index = this.clients.findIndex(c => c.id === client.id);
              if (index > -1) {
                this.clients.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  // openSaveClient(client = new Client()) {
  //   this.dialogService.addDialog(SaveClientComponent, {
  //     client: client
  //   }, this.utilService.getModalOptions()).subscribe((result) => {
  //       if(result && result.success){
  //         this.getClients(this.page);
  //         this.toastr.success('Registro salvo.', 'Sucesso');
  //       }
  //   });
  // }


}
